import { ClassicButton } from "../components/Buttons.js";
import { PhaseCard } from "../components/Cards.js";

const Loadmap = () => {
  const phasesText = [
    [
      ["Prelaunch"],
      [
        "Launching Discord and website",
        "Release Whitepaper",
        "Whitelist opening",
      ],
    ],
    [
      ["Community and connection"],
      ["Community and connection", "Lion Travelers NFT pre-sale"],
    ],
    [
      ["Public Collection Launch"],
      [
        "Lion NFTs public-sale",
        "Publish the 1st edition on OpenSea",
        "Publish the editions from 2nd to 8th",
        "Whitelist presale",
        "Sale on OpenSea",
      ],
    ],
    [
      ["Airdrop Dimension Cards"],
      [
        "The action begins! Airdrop open to all holders",
        "Each Lion can airdrop 12",
        "Dimensions",
      ],
    ],
    [
      ["BuyBack offer"],
      [
        "Purchase agreement: smart contract",
        "Holders start their strategy:",
        "keep it or sell it?",
      ],
    ],
    [
      ["Access to:"],
      ["Reef Business Club rewards", "Exclusive IRL meetings and events"],
    ],
    [
      ["Vaults"],
      [
        "NFT Vault deposit with constant",
        "APY up to 60%",
        "Mint or buy Vault to receive a fee on all capital gain",
      ],
    ],
    [["to be continued …"], ["Stay tuned!"]],
  ];

  const PhasesHTML = ({ min, max }) => {
    const result = phasesText.map((phase, index) => {
      let addClass = "";
      if (index % 2 === 0) addClass = "order-lg-last";
      if (index >= min && index <= max) {
        return (
          <div className="row timeline__event" key={index}>
            <div
              className={"col-12 col-lg-4 timeline__event__date " + addClass}
            >
              <h6>0{(index + 1).toString()}</h6>
              <h4>Phase</h4>
            </div>
            <PhaseCard title={phase[0]} content={phase[1]} />
          </div>
        );
      } else return "";
    });

    return result;
  };

  return (
    <div className="container" id="roadmap">
      <div className="row">
        <div className="col-12 pre">
          <h3>The Roadmap</h3>
          <h2>Our ideas and plans</h2>
        </div>
        <div className="col-12 col-lg-6 fasi">
          <ClassicButton text="Phase 1-4" classname="btn pixel" />
          <div>
            <PhasesHTML min={0} max={3} />
          </div>
        </div>
        <div className="col-12 col-lg-6 fasi">
          <ClassicButton text="Phase 5-8" classname="btn pixel" />
          <div>
            <PhasesHTML min={4} max={7} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loadmap;
